// removed by extract-text-webpack-plugin
module.exports = {"detailOptionWrap":"qempo_DetailOption_detailOptionWrap-3fQF-le","pillWrap":"qempo_DetailOption_pillWrap-3E5iya4","pill":"qempo_DetailOption_pill-3YZNuhG","active":"qempo_DetailOption_active-317IOZS","error":"qempo_DetailOption_error-3FlQCeF","disabled":"qempo_DetailOption_disabled-208NyUI","selectWrap":"qempo_DetailOption_selectWrap-2vVFxo1","label":"qempo_DetailOption_label-huOcWCb"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/ProductStep/components/DetailOption/DetailOption.scss
// module id = 1635
// module chunks = 0